<template>
     <div style="height:100vh">
        <embed style="width: 100%; height: 100%" :src="stringPDF" v-if="exibirPDF">
     </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import CardExibirPDF from '@/template/CardExibirPDF.vue'
import { baseApiUrl } from '@/config/global'

export default defineComponent({
  components: { CardExibirPDF},
  data(){
    return{
       nomeDocumentoPDF: 'Validação Holerite',
       exibirPDF:false,
       stringPDF:"data:application/pdf;base64,"
    }
  },
  created(){
    let {chave} = this.$route.params
    this.$http.get(`${baseApiUrl}/publicos/validarholerite/${chave}`).then(res =>{
      
      this.nomeDocumentoPDF = res.data.nomeArquivo
      this.stringPDF +=res.data.dadosRelatorioBase64
      this.exibirPDF = true

    })
  }
})
</script>
